import { defineMessages } from 'react-intl'

import { NOTIFICATION_CHANNEL } from './constants'

export const notificationChannelMessages = defineMessages({
  [NOTIFICATION_CHANNEL.EMAIL]: {
    id: 'dictionary.email',
    defaultMessage: 'Email'
  },
  [NOTIFICATION_CHANNEL.WHATSAPP]: {
    id: 'dictionary.whatsapp',
    defaultMessage: 'Whatsapp'
  },
  [NOTIFICATION_CHANNEL.PHONE]: {
    id: 'dictionary.phone',
    defaultMessage: 'Phone'
  },
  [NOTIFICATION_CHANNEL.SOCIAL_MEDIA]: {
    id: 'dictionary.socialMedia',
    defaultMessage: 'Social Media'
  }
})
